import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { Label } from "./ui/label";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ContactSection() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Please fill in all fields");
      return;
    }
    setSending(true);
    try {
      await axios.post(`${API}/contact`, form);
      toast.success("Message sent successfully!");
      setForm({ name: "", email: "", message: "" });
    } catch {
      toast.error("Failed to send message. Please try again.");
    }
    setSending(false);
  };

  return (
    <section id="contact" data-testid="contact-section" className="py-20 md:py-32 bg-zinc-950/50">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div className="max-w-xl">
          <p className="text-rose-700 uppercase tracking-[0.3em] text-sm font-bold">
            Reach Out
          </p>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-white mt-3 tracking-tight">
            Get in Touch
          </h2>
          <p className="text-zinc-400 mt-4 leading-relaxed">
            Feel free to reach out. All messages received are read.
          </p>

          <form onSubmit={handleSubmit} className="mt-10 space-y-6">
            <div>
              <Label className="text-zinc-400 text-xs uppercase tracking-widest">Name</Label>
              <Input
                data-testid="contact-name"
                value={form.name}
                onChange={e => setForm({ ...form, name: e.target.value })}
                className="mt-2 bg-zinc-900/50 border-white/10 text-white placeholder:text-zinc-600 rounded-none h-12 focus:border-rose-700"
                placeholder="Your name"
              />
            </div>
            <div>
              <Label className="text-zinc-400 text-xs uppercase tracking-widest">Email</Label>
              <Input
                data-testid="contact-email"
                type="email"
                value={form.email}
                onChange={e => setForm({ ...form, email: e.target.value })}
                className="mt-2 bg-zinc-900/50 border-white/10 text-white placeholder:text-zinc-600 rounded-none h-12 focus:border-rose-700"
                placeholder="your@email.com"
              />
            </div>
            <div>
              <Label className="text-zinc-400 text-xs uppercase tracking-widest">Message</Label>
              <Textarea
                data-testid="contact-message"
                value={form.message}
                onChange={e => setForm({ ...form, message: e.target.value })}
                className="mt-2 bg-zinc-900/50 border-white/10 text-white placeholder:text-zinc-600 rounded-none min-h-[160px] focus:border-rose-700"
                placeholder="Your message..."
              />
            </div>
            <Button
              type="submit"
              disabled={sending}
              data-testid="contact-submit-btn"
              className="bg-rose-700 hover:bg-rose-800 text-white rounded-none px-8 py-6 text-sm uppercase tracking-widest"
            >
              {sending ? "Sending..." : "Send Message"}
              <Send className="ml-2 h-4 w-4" />
            </Button>
          </form>
        </div>
      </div>
    </section>
  );
}
